<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Montagem de Carga por CTE</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a @click="onCreate()" v-b-tooltip title="Cadastrar"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onBip(null, 1)"
                      v-b-tooltip
                      title="Montar Carga por chave"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('parambanco.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('parambanco.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar> </vuetable-filterbar>
                </div>
                <div class="table-responsive">
                  <b-col md="6" offset-md="6">
                    <b-row no-gutters>
                      <b-col class="p-0">
                        <AvisoErros
                          v-bind:errors_array="errors_array"
                        ></AvisoErros>
                        <div class="loadingData" v-if="loadingDataStore">
                          <div class="loadingDataSpinner">
                            <spinner
                              v-if="loadingDataStore"
                              text-fg-color="#ffffff"
                              message="Carregando..."
                            ></spinner>
                          </div>
                        </div>
                      </b-col>
                      <b-col class="p-0">
                        <label>Vlr. total docs</label>
                        <currency-input
                          class="form-control"
                          v-model="form.vlr_total_ctes"
                          placeholder="Vlr. total nfs"
                          disabled
                          :auto-decimal-mode="true"
                          :currency="{ prefix: 'R$ ' }"
                          :distraction-free="getCurrency"
                        />
                      </b-col>
                      <b-col class="p-0">
                        <label>Peso total bruto</label>
                        <currency-input
                          class="form-control"
                          v-model="form.vlr_total_peso_bruto"
                          placeholder="Peso total bruto"
                          disabled
                          :auto-decimal-mode="true"
                          :currency="{ prefix: ' ' }"
                          :distraction-free="getCurrency"
                        />
                      </b-col>
                      <b-col class="p-0">
                        <label>Peso total liq.</label>
                        <currency-input
                          class="form-control"
                          v-model="form.vlr_total_peso_liquido"
                          placeholder="Peso total liq."
                          disabled
                          :auto-decimal-mode="true"
                          :currency="{ prefix: ' ' }"
                          :distraction-free="getCurrency"
                        />
                      </b-col>
                      <b-col class="p-0">
                        <label>Volume total</label>
                        <currency-input
                          class="form-control"
                          v-model="form.vlr_total_volume"
                          placeholder="Total volume"
                          disabled
                          :auto-decimal-mode="true"
                          :currency="{ prefix: ' ' }"
                          :distraction-free="getCurrency"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <div>
                    <a
                      @click="searchAll()"
                      v-b-tooltip
                      title="Selecionar todas as páginas"
                      v-if="getPermissionFw('montagemporcte.index')"
                      ><i
                        class="fa fa-check-square-o fa-lg"
                        style="margin: 0px 0px 5px 4px"
                      ></i
                    ></a>
                  </div>

                  <vuetable
                    ref="vuetable"
                    api-url="/api/montagemporcte"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="doc_id"
                    pagination-path=""
                    detail-row-component="montagemcargacte-detalhes"
                    @vuetable:cell-clicked="onDetail"
                    @vuetable:load-error="onError"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="num_carga" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.carga_bip_doc &&
                          props.rowData.carga_bip_doc.carga
                        "
                        >{{ props.rowData.carga_bip_doc.carga.num_carga }}</span
                      >
                    </template>
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="status_montagem" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="
                          props.rowData.doc_carga_doc[0].carga_doc &&
                          props.rowData.doc_carga_doc[0].carga_doc.carga &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga.status.valor == 1
                        "
                        >{{
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga.status.descr
                        }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="
                          props.rowData.doc_carga_doc[0].carga_doc &&
                          props.rowData.doc_carga_doc[0].carga_doc.carga &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga.status.valor == 2
                        "
                        >{{
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga.status.descr
                        }}</span
                      >
                      <span
                        class="badge badge-info"
                        v-if="
                          props.rowData.doc_carga_doc[0].carga_doc &&
                          props.rowData.doc_carga_doc[0].carga_doc.carga &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga.status.valor == 3
                        "
                        >{{
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga.status.descr
                        }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="
                          props.rowData.doc_carga_doc[0].carga_doc &&
                          props.rowData.doc_carga_doc[0].carga_doc.carga &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga.status.valor == 4
                        "
                        >{{
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga.status.descr
                        }}</span
                      >
                      <span
                        class="badge badge-secondary"
                        v-if="
                          props.rowData.doc_carga_doc[0].carga_doc &&
                          props.rowData.doc_carga_doc[0].carga_doc.carga &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga.status.valor == 5
                        "
                        >{{
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga.status.descr
                        }}</span
                      >
                      <span
                        class="badge badge-secondary"
                        v-if="
                          props.rowData.doc_carga_doc[0].carga_doc == null ||
                          (props.rowData.doc_carga_doc[0].carga_doc != null &&
                            props.rowData.doc_carga_doc[0].carga_doc
                              .doc_fiscal == null) ||
                          (props.rowData.doc_carga_doc[0].carga_doc != null &&
                            props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                              .carga_bip_doc == null)
                        "
                        >Sem carga iniciada</span
                      >
                    </template>
                    <template slot="tp_operacao" slot-scope="props">
                      <span
                        class="badge badge-danger"
                        v-if="
                          props.rowData.carga_doc &&
                          props.rowData.carga_doc.doc_carga_doc &&
                          props.rowData.carga_doc.doc_carga_doc.doc &&
                          props.rowData.carga_doc.doc_carga_doc.doc.tp_operacao
                            .valor == 1
                        "
                        >{{
                          props.rowData.carga_doc.doc_carga_doc.doc.tp_operacao
                            .descr
                        }}</span
                      >
                      <span
                        class="badge badge-success"
                        v-if="
                          props.rowData.carga_doc &&
                          props.rowData.carga_doc.doc_carga_doc &&
                          props.rowData.carga_doc.doc_carga_doc.doc &&
                          props.rowData.carga_doc.doc_carga_doc.doc.tp_operacao
                            .valor == 2
                        "
                        >{{
                          props.rowData.carga_doc.doc_carga_doc.doc.tp_operacao
                            .descr
                        }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="
                          props.rowData.carga_doc &&
                          props.rowData.carga_doc.doc_carga_doc &&
                          props.rowData.carga_doc.doc_carga_doc.doc &&
                          props.rowData.carga_doc.doc_carga_doc.doc.tp_operacao
                            .valor == 3
                        "
                        >{{
                          props.rowData.carga_doc.doc_carga_doc.doc.tp_operacao
                            .descr
                        }}</span
                      >
                    </template>
                    <template slot="cliente" slot-scope="props">
                      <span
                        >{{ props.rowData.doc_cte_partes_env.des_nome }} -
                        {{ props.rowData.doc_cte_partes_env.des_cnpj }}
                        {{ props.rowData.doc_cte_partes_env.des_cpf }}
                      </span>
                    </template>
                    <template slot="remetente" slot-scope="props">
                      <span
                        >{{ props.rowData.doc_cte_partes_env.rem_nome }}
                      </span>
                    </template>
                    <template slot="recebedor" slot-scope="props">
                      <span
                        >{{ props.rowData.doc_cte_partes_env.rec_nome + " - " +  props.rowData.doc_cte_partes_env.rec_nome_municipio}}
                      </span>
                    </template>
                    <template slot="num_carga" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga
                        "
                      >
                        {{
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga.num_carga
                        }}
                      </span>
                    </template>
                    <template slot="tp_processo" slot-scope="props">
                      <span
                        class="badge badge-danger"
                        v-if="
                          props.rowData.carga_doc &&
                          props.rowData.carga_doc.doc_carga_doc &&
                          props.rowData.carga_doc.doc_carga_doc.doc &&
                          props.rowData.carga_doc.doc_carga_doc.doc.tp_processo
                            .valor == 1
                        "
                        >{{
                          props.rowData.carga_doc.doc_carga_doc.doc.tp_processo
                            .descr
                        }}</span
                      >
                      <span
                        class="badge badge-success"
                        v-if="
                          props.rowData.carga_doc &&
                          props.rowData.carga_doc.doc_carga_doc &&
                          props.rowData.carga_doc.doc_carga_doc.doc &&
                          props.rowData.carga_doc.doc_carga_doc.doc.tp_processo
                            .valor == 2
                        "
                        >{{
                          props.rowData.carga_doc.doc_carga_doc.doc.tp_processo
                            .descr
                        }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="
                          props.rowData.carga_doc &&
                          props.rowData.carga_doc.doc_carga_doc &&
                          props.rowData.carga_doc.doc_carga_doc.doc &&
                          props.rowData.carga_doc.doc_carga_doc.doc.tp_processo
                            .valor == 3
                        "
                        >{{
                          props.rowData.carga_doc.doc_carga_doc.doc.tp_processo
                            .descr
                        }}</span
                      >
                      <span
                        class="badge badge-info"
                        v-if="
                          props.rowData.carga_doc &&
                          props.rowData.carga_doc.doc_carga_doc &&
                          props.rowData.carga_doc.doc_carga_doc.doc &&
                          props.rowData.carga_doc.doc_carga_doc.doc.tp_processo
                            .valor == 4
                        "
                        >{{
                          props.rowData.carga_doc.doc_carga_doc.doc.tp_processo
                            .descr
                        }}</span
                      >
                      <span
                        class="badge badge-secundary"
                        v-if="
                          props.rowData.carga_doc &&
                          props.rowData.carga_doc.doc_carga_doc &&
                          props.rowData.carga_doc.doc_carga_doc.doc &&
                          props.rowData.carga_doc.doc_carga_doc.doc.tp_processo
                            .valor == 5
                        "
                        >{{
                          props.rowData.carga_doc.doc_carga_doc.doc.tp_processo
                            .descr
                        }}</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <a
                        v-if="
                          props.rowData.doc_carga_doc[0].carga_doc &&
                          props.rowData.doc_carga_doc[0].carga_doc.carga &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga &&
                          props.rowData.doc_carga_doc[0].carga_doc.doc_fiscal
                            .carga_bip_doc.carga.status.valor == 2
                        "
                        @click="onBip(props.rowData, 2)"
                        v-b-tooltip
                        title="Adicionar nota fiscal a carga"
                        ><i class="fa fa-file"></i
                      ></a>
                      <a
                        @click="onDetail(props.rowData, null, null)"
                        v-b-tooltip
                        title="Ver detalhes"
                        ><i class="fa fa-plus"></i
                      ></a>
                      <div class="custom-actions"></div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MontagemCargaPorCteModal ref="montagemcargaporctemodal" />
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import moment from "moment";
import accounting from "accounting";
import AvisoErros from "../components/AvisoErros";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import MontagemCargaPorCteFilterBar from "./MontagemCargaPorCteFilterBar.vue";
import MontagemCargaPorCteModal from "./MontagemCargaPorCteModal.vue";
import MontagemCargaPorCteDetalhes from "./MontagemCargaPorCteDetalhes.vue";

Vue.component("montagemcargacte-detalhes", MontagemCargaPorCteDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    AvisoErros,
    MontagemCargaPorCteModal,
    MontagemCargaPorCteDetalhes,
    "vuetable-filterbar": MontagemCargaPorCteFilterBar,
  },
  data() {
    return {
      errors_array: [],
      dataExport: [],
      dados: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      municipioOptions: [],
      statusBipOptions: [],
      statusCargaOptions: [],
      tpCargaOptions: [],
      tpOperacaoOptions: [],
      tpProcessoOptions: [],
      ufOptions: [],
      loading: false,
      filter_data_store: {},
      filtros_form: new Form({
        num_carga: "",
        num_fiscal_cte_ini: "",
        num_fiscal_cte_fim: "",
        num_fiscal: "",
        status_carga: "",
        recebedor: "",
        dt_emi_ini: "",
        dt_emi_fim: "",
        cnpj_origem: "",
        cnpj_des_rec: "",
        municipio_des_rec: "",
        uf_des_rec: "",
        tp_operacao: "",
        tp_processo: "",
        municipio_emi: "",
        uf_emi: "",
      }),
      loadingData: true,
      loadingDataStore: false,
      showModal: false,
      form: new Form({
        docs: [],
        vlr_total_ctes: 0,
        vlr_total_peso_bruto: 0,
        vlr_total_peso_liquido: 0,
        vlr_total_volume: 0,
        vlr_total_ctes2: 0,
        vlr_total_peso_liquido2: 0,
        vlr_total_peso_bruto2: 0,
        vlr_total_volume2: 0,
      }),
      helpForm: new Form({ recordCollection: [], status: "" }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "num_fiscal",
          title: "Doc",
        },
        {
          name: "tp_doc.descr",
          title: "Tipo Doc",
        },
        {
          name: "__slot:num_carga",
          title: "N° Carga",
        },
        {
          name: "__slot:status_montagem",
          title: "Status Carga",
        },
        {
          name: "tp_processo.descr",
          title: "Processo",
        },
        {
          name: "tp_operacao.descr",
          title: "Operação",
        },
        {
          name: "dt_emi",
          title: "Data emissão",
          callback: "formatDate|DD/MM/YYYY",
        },
        {
          name: "__slot:cliente",
          title: "Cliente",
        },
        {
          name: "__slot:remetente",
          title: "Remetente",
        },
        {
          name: "__slot:recebedor",
          title: "Recebedor",
        },
        {
          name: "peso_bruto",
          title: "Peso bruto",
          callback: "formatNumber",
        },
        {
          name: "peso_liquido",
          title: "Peso líquido",
          callback: "formatNumber",
        },
        {
          name: "qtd_volume",
          title: "Volume",
        },
        {
          name: "vlr_prestacao",
          title: "Valor DOC",
          callback: "formatNumber",
        },
        {
          name: "__slot:actions",
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.getLivGeral();
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    searchAll(data_filter, tipo) {
      // if(this.$refs.vuetable.selectedTo.length > 0){
      //    this.$refs.vuetable.selectedTo = [];
      // }
      if (tipo == 2) {
        this.filter_data_store = data_filter;
      }
      if (tipo != 2) {
        this.loadingData = true;
        if (this.$refs.vuetable.selectedTo.length == 0) {
          this.filtros_form.num_carga = this.filter_data_store.num_carga;
          this.filtros_form.num_fiscal_cte_ini =
            this.filter_data_store.num_fiscal_cte_ini;
          this.filtros_form.num_fiscal_cte_fim =
            this.filter_data_store.num_fiscal_cte_fim;
          this.filtros_form.num_fiscal = this.filter_data_store.num_fiscal;
          this.filtros_form.status_carga = this.filter_data_store.status_carga;
          this.filtros_form.recebedor = this.filter_data_store.recebedor;
          this.filtros_form.dt_emi_ini = this.filter_data_store.dt_emi_ini;
          this.filtros_form.dt_emi_fim = this.filter_data_store.dt_emi_fim;
          this.filtros_form.cnpj_origem = this.filter_data_store.cnpj_origem;
          this.filtros_form.cnpj_des_rec = this.filter_data_store.cnpj_des_rec;
          this.filtros_form.municipio_des_rec =
            this.filter_data_store.municipio_des_rec;
          this.filtros_form.uf_des_rec = this.filter_data_store.uf_des_rec;
          this.filtros_form.tp_operacao = this.filter_data_store.tp_operacao;
          this.filtros_form.tp_processo = this.filter_data_store.tp_processo;
          this.filtros_form.municipio_emi =
            this.filter_data_store.municipio_emi;
          this.filtros_form.uf_emi = this.filter_data_store.uf_emi;
          this.filtros_form
            .post("/api/montagemporcte/all")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);
              response.forEach((obj) => {
                this.$refs.vuetable.selectedTo.push(parseFloat(obj.doc_id));
                this.form.vlr_total_ctes += obj.vlr_prestacao;
                this.form.vlr_total_peso_liquido += obj.peso_liquido;
                this.form.vlr_total_peso_bruto += obj.peso_bruto;
                this.form.vlr_total_volume += parseFloat(obj.qtd_volume);
                console.log("this.form.vlr_total_volume");
                console.log(obj.qtd_volume + " - ");
              });
              this.loadingData = false;
            })
            .catch((errors) => {
              new ReturnApi(errors, this);
              this.loadingData = false;
            });
        } else {
          this.form.vlr_total_ctes = 0;
          this.form.vlr_total_peso_liquido = 0;
          this.form.vlr_total_peso_bruto = 0;
          this.form.vlr_total_volume = 0;
          this.$refs.vuetable.selectedTo = [];
          this.loadingData = false;
        }
      }
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      if (data_filter.recebedor == 2) {
        this.uf_des = data_filter.uf_des_rec.value;
        this.municipio_des = data_filter.municipio_des_rec.value;
        this.cnpj_destinatario = data_filter.cnpj_des_rec;
        this.uf_rec = "";
        this.cnpj_recebedor = "";
        this.municipio_rec = "";
      } else {
        this.uf_rec = data_filter.uf_des_rec.value;
        this.cnpj_recebedor = data_filter.cnpj_des_rec;
        this.municipio_rec = data_filter.municipio_des_rec.value;
        this.cnpj_destinatario = "";
        this.uf_des = "";
        this.municipio_des = "";
      }
      this.moreParams = {
        recebedor: data_filter.recebedor,
        num_carga: data_filter.num_carga,
        obs: data_filter.obs,
        num_fiscal_cte_ini: data_filter.num_fiscal_cte_ini,
        num_fiscal_cte_fim: data_filter.num_fiscal_cte_fim,
        num_fiscal: data_filter.num_fiscal,
        status_carga: data_filter.status_carga.value,
        dt_emi_ini: data_filter.dt_emi_ini,
        dt_emi_fim: data_filter.dt_emi_fim,
        cnpj_origem: data_filter.cnpj_origem,
        cnpj_destinatario: this.cnpj_destinatario,
        cnpj_recebedor: this.cnpj_recebedor,
        municipio_des: this.municipio_des,
        municipio_rec: this.municipio_rec,
        tp_operacao: data_filter.tp_operacao.value,
        tp_processo: data_filter.tp_processo.value,
        municipio_emi: data_filter.municipio_emi.value,
        uf_emi: data_filter.uf_emi.value,
        uf_des: this.uf_des,
        uf_rec: this.uf_rec,
      };
      if (JSON.stringify(this.moreParams) != "{}") {
        this.searchAll(this.moreParams, 2);
      }
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      this.$refs.vuetable.selectedTo = [];
      this.filter_data_store = {};
      this.form.vlr_total_ctes = 0;
      this.form.vlr_total_peso_liquido = 0;
      this.form.vlr_total_peso_bruto = 0;
      this.form.vlr_total_volume = 0;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onLoaded: function () {
      this.dataExport.push(this.$refs.vuetable.tableData);
      this.dataExport.forEach((obj2) => {
        obj2.forEach((obj3) => {
          this.dados.push({
            doc_id: obj3.doc_id,
            vlr_prestacao: obj3.vlr_prestacao,
            peso_bruto_total: obj3.peso_bruto,
            peso_liquido_total: obj3.peso_liquido,
            volume_total: obj3.qtd_volume,
          });
        });
      });
      this.loadingData = false;
      this.$watch(
        () => {
          return this.$refs.vuetable.selectedTo;
        },
        (obj) => {
          this.somaValoresNfs(obj);
        }
      );
      this.$store.commit("setVuetableFilterButton", false);
    },
    onCreate() {
      this.form.docs = [];
      if (this.$refs.vuetable && this.$refs.vuetable.selectedTo.length > 0) {
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.form.docs.push({ doc_id: obj });
        });
        this.form
          .post("/api/montagemporcte/store")
          .then((response) => {
            new ReturnApi(response, this, true, null, null, false);
            this.onFilterReset();
            this.docfis = [];
            this.loadingDataStore = false;
            this.$refs.vuetable.selectedTo = [];
          })
          .catch((errors) => {
            new ReturnApi(errors, this, true, null, null, false);
            this.loadingDataStore = false;
            this.errors_array = "";
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof errors[property] === "object") {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj,
                    });
                  });
                }
              }
            }
          });
      }
    },
    onBip(data, tipo) {
      this.$refs.vuetable.selectedTo = [];
      this.$refs.montagemcargaporctemodal.onCreate(data, tipo);
    },
    onEdit(data, index) {
      this.id = data.parban_id;
      this.$refs.paramsform.onEdit(data, index, this.id);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.doc_id);
    },
    getLivGeral() {
      this.helpForm
        .get("/api/montagemporcte/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.municipio.forEach((obj) => {
            this.municipioOptions.push({
              label: obj.nome + " - " + obj.uf.cd,
              value: obj.cd_ibge,
            });
          }),
            response.status_bip.forEach((obj) => {
              this.statusBipOptions.push({
                label: obj.descr,
                value: obj.valor,
              });
            });
          response.status_carga.forEach((obj) => {
            this.statusCargaOptions.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.tipo_carga.forEach((obj) => {
            this.tpCargaOptions.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_operacao.forEach((obj) => {
            this.tpOperacaoOptions.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_processo.forEach((obj) => {
            this.tpProcessoOptions.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.uf.forEach((obj) => {
            this.ufOptions.push({
              label: obj.cd,
              value: obj.cd,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    somaValoresNfs(obj) {
      this.form.vlr_total_ctes2 = 0;
      this.form.vlr_total_peso_liquido2 = 0;
      this.form.vlr_total_peso_bruto2 = 0;
      this.form.vlr_total_volume2 = 0;
      obj.forEach((item) => {
        this.data = this.dados.filter((item2) => item2.doc_id === item);
        this.form.vlr_total_ctes2 =
          parseFloat(this.data[0].vlr_prestacao) + this.form.vlr_total_ctes2;

        this.form.vlr_total_peso_liquido2 =
          parseFloat(this.data[0].peso_liquido_total) +
          this.form.vlr_total_peso_liquido2;
        console.log('this.data[0].peso_bruto');
        console.log(this.data[0]);
        this.form.vlr_total_peso_bruto2 =
          parseFloat(this.data[0].peso_bruto_total) +
          this.form.vlr_total_peso_bruto2;

        this.form.vlr_total_volume2 =
          parseFloat(this.data[0].volume_total) + this.form.vlr_total_volume2;

      });

      if (this.$refs.vuetable.selectedTo.length == 0) {
        this.form.vlr_total_ctes = 0;
        this.form.vlr_total_peso_liquido = 0;
        this.form.vlr_total_peso_bruto = 0;
        this.form.vlr_total_volume = 0;
      }

      if (this.form.vlr_total_ctes2 != 0) {
        this.form.vlr_total_ctes = this.form.vlr_total_ctes2;
      }
      if (this.form.vlr_total_peso_liquido2 != 0) {
        this.form.vlr_total_peso_liquido = this.form.vlr_total_peso_liquido2;
      }
      if (this.form.vlr_total_peso_bruto2 != 0) {
        this.form.vlr_total_peso_bruto = this.form.vlr_total_peso_bruto2;
      }
      if (this.form.vlr_total_volume2 != 0) {
        this.form.vlr_total_volume = this.form.vlr_total_volume2;
      }
      // obj.forEach((item, i) => {
      //   this.data = this.dataExport.filter((item2) => item2.doc_id === item);
      //   this.form.vlr_total_ctes =
      //     parseFloat(this.data[0].vlr_prestacao) + this.form.vlr_total_ctes;
      //   this.form.vlr_total_peso_liquido =
      //     parseFloat(this.data[0].peso_liquido_total) +
      //     this.form.vlr_total_peso_liquido;
      //   this.form.vlr_total_peso_bruto =
      //     parseFloat(this.data[0].peso_bruto_total) +
      //     this.form.vlr_total_peso_bruto;
      //   this.form.vlr_total_volume =
      //     parseFloat(this.data[0].volume_total) + this.form.vlr_total_volume;
      // });
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.parban_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.paramsform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    formatDate(value, fmt = "DD MM YYYY") {
      return value == null ? "" : moment(value, "YYYY/MM/DD").format(fmt);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
  },
};
</script>
